var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('div',{staticStyle:{"width":"300px","background-color":"#ffe57d","border-radius":"10px","text-align":"left","font-family":"notosansregular"}},[_c('p',{staticStyle:{"margin":"auto","padding":"10px"}},[_vm._v(_vm._s(_vm.mention))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }